<div class="wrapper wrapper-medium">
    <div class="header">
        <h1>Pending Reviews</h1>
        <p class="marto-10">Review and approve documents that require your attention.</p>
    </div>

    <!-- Tabs row -->
    <div class="review-tabs-row" data-testid="review-tabs-row">
        <div class="review-tabs" data-testid="review-tabs">
            <button *ngFor="let tab of tabs" class="tab-button" [class.active]="isActiveTab(tab.type)"
                (click)="setActiveTab(tab.type)" [attr.data-testid]="'tab-' + tab.type">
                {{ tab.label }}
                <span class="tab-count" *ngIf="tab.count > 0">{{ tab.count }}</span>
            </button>
        </div>
    </div>

    <!-- Filter + Refresh row -->
    <div class="controls-row" data-testid="review-controls-row">
        <div class="controls-row-left" data-testid="household-filter-section">
            <app-household-filter [selected_household_id]="selected_household_id" [compact]="true"
                (household_filter_changed)="onHouseholdFilterChange($event)"
                (household_lookup_loaded)="onHouseholdLookupLoaded($event)">
            </app-household-filter>
        </div>

        <div class="controls-row-right" data-testid="refresh-section">
            <button data-testid="btn-refresh" class="btn btn-secondary btn-small" (click)="refreshReviews()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                </svg>
                <span>Refresh</span>
            </button>
        </div>
    </div>

    <!-- Loading indicator -->
    <div *ngIf="is_loading" class="loading-indicator" data-testid="loading-indicator">
        <loading message="retrieving reviews..."></loading>
    </div>

    <!-- Separation Reviews Section -->
    <div *ngIf="!is_loading && isActiveTab('separation')" class="review-section"
        data-testid="separation-reviews-section">

        <!-- Empty state -->
        <div *ngIf="separation_reviews.length === 0" class="empty-state" data-testid="separation-empty-state">
            <div class="empty-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <path d="M9 15l2 2 4-4" />
                </svg>
            </div>
            <p class="empty-message">No separation reviews pending</p>
            <p class="empty-hint">Documents requiring separation review will appear here</p>
        </div>

        <!-- Reviews list -->
        <div *ngIf="separation_reviews.length > 0" class="list-container" data-testid="separation-reviews-list">
            <div *ngFor="let review of paginated_separation_reviews; let i = index" class="list-item"
                (click)="openReview(review.documentId, 'separation')"
                [attr.data-testid]="'separation-review-item-' + i">
                <div class="item-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                    </svg>
                </div>
                <div class="item-details">
                    <span class="item-name" [attr.data-testid]="'separation-review-id-' + i">{{
                        getDocumentDisplayName(review.documentId, review.originalFilename) }}</span>
                    <span class="item-subtitle" [attr.data-testid]="'separation-review-info-' + i">
                        {{ review.childDocumentCount || '?' }} child documents
                        <span class="household-label"> • Household: {{ getHouseholdName(review.household) }}</span>
                    </span>
                </div>
                <div class="review-meta">
                    <span class="status-badge" [class.expiring]="isExpiringSoon(review.taskTokenExpiresAt)"
                        [class.expired]="isExpired(review.taskTokenExpiresAt)"
                        [attr.data-testid]="'separation-review-status-' + i">
                        <ng-container *ngIf="isExpired(review.taskTokenExpiresAt)">Expired</ng-container>
                        <ng-container
                            *ngIf="isExpiringSoon(review.taskTokenExpiresAt) && !isExpired(review.taskTokenExpiresAt)">Expiring
                            Soon</ng-container>
                        <ng-container
                            *ngIf="!isExpiringSoon(review.taskTokenExpiresAt) && !isExpired(review.taskTokenExpiresAt)">Pending</ng-container>
                    </span>
                    <span class="review-date" [attr.data-testid]="'separation-review-date-' + i">
                        Created {{ formatDate(review.taskTokenCreatedAt) }}
                    </span>
                </div>
            </div>

            <!-- Pagination footer -->
            <div class="pagination-footer flex-row flex-center-y flex-space-between"
                data-testid="separation-pagination-footer">
                <div class="pagination-info">
                    <p data-testid="separation-pagination-results-info">
                        Showing {{ separation_showing_from }}–{{ separation_showing_to }} of {{ separation_total_items
                        }} reviews
                    </p>
                </div>
                <div class="pagination-center flex-row flex-center-y">
                    <button data-testid="btn-separation-first-page" class="btn btn-secondary btn-small"
                        (click)="separationFirstPage()" [disabled]="separation_current_page === 1">
                        « First
                    </button>
                    <button data-testid="btn-separation-prev-page" class="btn btn-secondary btn-small"
                        (click)="separationPrevPage()" [disabled]="separation_current_page === 1"
                        style="margin-left: 6px;">
                        ‹ Prev
                    </button>
                    <span data-testid="separation-pagination-info" style="margin: 0 10px;">Page {{
                        separation_current_page }} of {{ separation_total_pages }}</span>
                    <button data-testid="btn-separation-next-page" class="btn btn-secondary btn-small"
                        (click)="separationNextPage()"
                        [disabled]="separation_current_page === separation_total_pages || separation_total_pages === 0"
                        style="margin-right: 6px;">
                        Next ›
                    </button>
                    <button data-testid="btn-separation-last-page" class="btn btn-secondary btn-small"
                        (click)="separationLastPage()"
                        [disabled]="separation_current_page === separation_total_pages || separation_total_pages === 0">
                        Last »
                    </button>
                </div>
                <div class="page-size flex-row flex-center-y">
                    <label for="separationPageSize" style="margin-right: 6px;">Per page</label>
                    <select id="separationPageSize" data-testid="select-separation-page-size"
                        [ngModel]="separation_page_size" (ngModelChange)="onSeparationPageSizeChange($event)">
                        <option [ngValue]="10">10</option>
                        <option [ngValue]="25">25</option>
                        <option [ngValue]="50">50</option>
                        <option [ngValue]="100">100</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <!-- Classification Reviews Section -->
    <div *ngIf="!is_loading && isActiveTab('classification')" class="review-section"
        data-testid="classification-reviews-section">

        <!-- Empty state -->
        <div *ngIf="classification_reviews.length === 0" class="empty-state" data-testid="classification-empty-state">
            <div class="empty-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <path d="M9 15l2 2 4-4" />
                </svg>
            </div>
            <p class="empty-message">No classification reviews pending</p>
            <p class="empty-hint">Documents requiring classification review will appear here</p>
        </div>

        <!-- Reviews list -->
        <div *ngIf="classification_reviews.length > 0" class="list-container" data-testid="classification-reviews-list">
            <div *ngFor="let review of paginated_classification_reviews; let i = index" class="list-item"
                (click)="openReview(review.documentId, 'classification')"
                [attr.data-testid]="'classification-review-item-' + i">
                <div class="item-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                    </svg>
                </div>
                <div class="item-details">
                    <span class="item-name" [attr.data-testid]="'classification-review-id-' + i">{{
                        getDocumentDisplayName(review.documentId, review.originalFilename) }}</span>
                    <span class="item-subtitle" [attr.data-testid]="'classification-review-info-' + i">
                        <span class="household-label">Household: {{ getHouseholdName(review.householdId) }}</span>
                    </span>
                </div>
            </div>

            <!-- Pagination footer -->
            <div class="pagination-footer flex-row flex-center-y flex-space-between"
                data-testid="classification-pagination-footer">
                <div class="pagination-info">
                    <p data-testid="classification-pagination-results-info">
                        Showing {{ classification_showing_from }}–{{ classification_showing_to }} of {{
                        classification_total_items }} reviews
                    </p>
                </div>
                <div class="pagination-center flex-row flex-center-y">
                    <button data-testid="btn-classification-first-page" class="btn btn-secondary btn-small"
                        (click)="classificationFirstPage()" [disabled]="classification_current_page === 1">
                        « First
                    </button>
                    <button data-testid="btn-classification-prev-page" class="btn btn-secondary btn-small"
                        (click)="classificationPrevPage()" [disabled]="classification_current_page === 1"
                        style="margin-left: 6px;">
                        ‹ Prev
                    </button>
                    <span data-testid="classification-pagination-info" style="margin: 0 10px;">Page {{
                        classification_current_page }} of {{ classification_total_pages }}</span>
                    <button data-testid="btn-classification-next-page" class="btn btn-secondary btn-small"
                        (click)="classificationNextPage()"
                        [disabled]="classification_current_page === classification_total_pages || classification_total_pages === 0"
                        style="margin-right: 6px;">
                        Next ›
                    </button>
                    <button data-testid="btn-classification-last-page" class="btn btn-secondary btn-small"
                        (click)="classificationLastPage()"
                        [disabled]="classification_current_page === classification_total_pages || classification_total_pages === 0">
                        Last »
                    </button>
                </div>
                <div class="page-size flex-row flex-center-y">
                    <label for="classificationPageSize" style="margin-right: 6px;">Per page</label>
                    <select id="classificationPageSize" data-testid="select-classification-page-size"
                        [ngModel]="classification_page_size" (ngModelChange)="onClassificationPageSizeChange($event)">
                        <option [ngValue]="10">10</option>
                        <option [ngValue]="25">25</option>
                        <option [ngValue]="50">50</option>
                        <option [ngValue]="100">100</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Classification Review Modal -->
<app-file-sidebar *ngIf="selected_classification_review" [fileId]="selected_classification_review.documentId"
    [isOpen]="is_classification_modal_open" [mode]="'classification_review'"
    [documentDetails]="selected_classification_review" [aiSuggestions]="selected_classification_review.aiCategorization"
    (close)="closeClassificationModal()" (onApprove)="handleClassificationApproval($event)">
</app-file-sidebar>

<!-- Loading overlay for classification modal -->
<div *ngIf="classification_modal_loading" class="modal-loading-overlay">
    <div class="modal-loading-spinner">
        <loading message="Loading classification review..."></loading>
    </div>
</div>

<!-- Separation Review Modal -->
<div class="separation-modal-overlay" [class.active]="is_separation_modal_open"
    *ngIf="is_separation_modal_open" (click)="closeSeparationModal()" data-testid="separation-modal-overlay"></div>

<div class="separation-modal" [class.open]="is_separation_modal_open" *ngIf="is_separation_modal_open"
    data-testid="separation-modal">
    <app-file-review *ngIf="selected_separation_document_id" [embedded]="true"
        [inputFileId]="selected_separation_document_id" (closed)="closeSeparationModal()"
        (reviewCompleted)="onSeparationCompleted()">
    </app-file-review>
</div>